import { useAppSelector } from '../../../hooks/hooks'
import { DATE_TYPES } from '../../../constants/constants'
import { differenceInDays, format } from 'date-fns'
import { parseDate } from '../../../utilities/helpers'
import { selectActiveDepartures, selectActiveDestinationGroups, selectActiveDestinations, selectActiveThemes } from '../../mainFilter/selectors'
import { getDateFnsLocale } from '../../../utilities/localeUtils'
import { useProposalContext } from 'travelyo-react-shared-components'
import { pushEvent } from '../../../utilities/analytics'
import { selectSecondaryFilter } from '../../secondaryFilter/secondaryFilterSlice'

type Offer = {
  capacity: {
    adult: number,
    child: number,
    infant: number | null,
  },
  outboundDate: string,
  currency: string,
  hfOfferId: string,
  price: number,
  duration: number,
  // ...
}

type LuggageItem = {
  label: string,
  value: 'canAddTrolley' | 'canAddCib',
  active: boolean
}

type Props = {
  offer: Offer,
}

const AddToProposal = ({
  offer,
}: Props) => {
  const when = useAppSelector(state => state.search.when);
  const { luggage, flex } = useAppSelector(selectSecondaryFilter).data;
  const activeThemes = useAppSelector(selectActiveThemes);
  const activeDestinationGroups = useAppSelector(selectActiveDestinationGroups);
  const activeDestinations = useAppSelector(selectActiveDestinations);
  const activeDepartures = useAppSelector(selectActiveDepartures);
  const who = useAppSelector(state => state.search.who);
  const { openProposal } = useProposalContext();

  const getSearchContext = () => {
    if (activeThemes.length > 0) {
      return activeThemes[0].value;
    }

    if (activeDestinationGroups.length > 0) {
      return activeDestinationGroups[0].name;
    }

    if (activeDestinations.length > 0) {
      return activeDestinations[0].name;
    }

    return '';
  }


  const getSearchDuration = () => {
    if (when.type === DATE_TYPES.SPECIFIC) {
      if (!when.startDate || !when.endDate) return;
      return differenceInDays(parseDate(when.endDate), parseDate(when.startDate));
    }

    return when.nights?.join(', ');
  }

  const offerData = {
    offerId: offer.hfOfferId,
    date: format(parseDate(offer.outboundDate), 'MMMM yyyy', { locale: getDateFnsLocale() }),
    searchContext: getSearchContext(),
    searchCapacity: `${offer.capacity.adult}-${offer.capacity.child + (offer.capacity.infant ?? 0)}`,
    searchDuration: getSearchDuration() || '',
    airports: activeDepartures.map((departure) => departure.id),
    originalPrice: offer.price,
    capacity: {
      ...offer.capacity,
      infant: offer.capacity?.infant || 0,
      room: offer.capacity?.room || 1,
      childAges: who.childAges,
    },
    filters: {
      luggage: {
        canAddTrolley: luggage.find((luggageItem: LuggageItem) => luggageItem.value === 'canAddTrolley')?.active,
        canAddCib: luggage.find((luggageItem: LuggageItem) => luggageItem.value === 'canAddCib')?.active,
      },
      flex: flex?.active,
    }
  }

  const hf_user = JSON.parse(localStorage.getItem('hf_user') || '{}');
  if (!hf_user?.user?.user_auth) {
    return null;
  }

  const onAddToProposalClick = () => {
    openProposal(offerData, 'list');
    pushEvent('proposals_addOfferToList')
  }

  return (
    <div className="location-icons-wrap" onClick={onAddToProposalClick}>
      <i className="ri-add-line" />
    </div>
  )
}

export default AddToProposal
